import React from "react";
import { ProductEventTarget } from "./ProductEventTarget";

export const ProductEventContext =
  React.createContext<ProductEventTarget | null>(null);
